




































import { defineComponent, computed } from '@vue/composition-api';
const name = 'ttam-interactive-add-on-update-menu';

export default defineComponent({
  name,
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
    isAddonEditBtnHide: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const dropDownMenus = computed(() => [
      ...(props.isAddonEditBtnHide
        ? []
        : [
            {
              command: 'update-by-edit',
              label: 'common_edit',
              clickEvent: 'module_ad_creative_product_card_edit_click',
              showEvent: 'module_ad_creative_product_card_edit_impression',
            },
          ]),
      {
        command: 'update-by-new',
        label: 'adgroup_create_title',
        clickEvent: 'ad_instant_page_editor_click_new',
        showEvent: 'ad_instant_page_editor_expose_new',
      },
      {
        command: 'update-by-library',
        label: 'module_ad_upload_operation_library',
        clickEvent: 'ad_instant_page_editor_click_update_from_library',
        showEvent: 'ad_instant_page_editor_expose_update_from_library',
      },
    ]);

    return {
      dropDownMenus,
      name,
    };
  },
});
